import { useState } from "react";
import LLMRecommendation from "./LLMRecommendation.js";

function FileContainer({ fileData, setOpenModel, setSelectedFile }: any) {
  const score = Number(fileData.predictionProbability) * 10;

  const getCircleColor = () => {
    if (score >= 7) return "bg-red-500/20 text-red-400 border-red-500";
    if (score >= 5) return "bg-orange-500/20 text-orange-300 border-orange-300";
    return "bg-green-500/20 text-green-200 border-green-200";
  };

  const openLLMRecommendation = () => {
    setSelectedFile(fileData.filename);
    setOpenModel(true);
  };

  return (
    <div className="px-8 py-4 flex flex-row items-center justify-between w-full rounded border border-green-500/30 bg-black hover:border-green-500 transition-colors">
      <div className="text-xl font-mono text-white">
        &gt; {fileData.filename}
      </div>
      <div className="flex flex-row items-center gap-4">
        <div
          className={`text-lg font-mono flex items-center justify-center w-16 h-16 rounded-full border-2 ${getCircleColor()}`}
        >
          <span className="font-bold">{score.toFixed(2)}</span>
        </div>
        {score >= 5 && (
          <button
            onClick={openLLMRecommendation}
            className="px-2 py-2 bg-green-500 text-black font-mono font-bold rounded hover:bg-green-400 transition-colors uppercase text-sm"
          >
            [ ASK AI ]
          </button>
        )}
      </div>
    </div>
  );
}

export default FileContainer;